// mutations.js
import * as types from './mutation-types';

export default {
    [types.FETCH_BADGELIST](state, payload) {
        state.badgeList = payload;
    },
};
